import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";

const features = [
  {
    gifUrl:
      "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExZXpvZXJoNzZydzl6NDI2MWw3ZnRkOW15azhlczNpaTE4ODdmcHVrOCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/db3w8YLWTxroBBPhML/giphy.gif",
    title: "Stress-Free Fun",
    description: "No setup fatigue, no learning curve",
  },
  {
    gifUrl:
      "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExdWFncmtyN3p5cHhlM3NueG51bmFzaXU4bGFvZWkybDd6eDNqamRpcCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/Id0B8pl1siJ9cesHc3/giphy.gif",
    title: "Inclusive & Engaging",
    description: "Great even for introverts",
  },
  {
    gifUrl:
      "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExZHdtdHRzaWh3MG02ZDBmY2QzcmgxdmY2c2t6czlkNnJhcjBxdXpmeSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/knLbKBXlmxjohGASi1/giphy.gif",
    title: "Branded & Themed",
    description: "Customize for your team or event",
  },
  {
    gifUrl:
      "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExZzRqNHNyZXFpcnZ2NDB1MnFrNHc5aTJqdHhpdnNnNnBjZTZldXB1biZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/Uojpp3DNH3HtLSeHSN/giphy.gif",
    title: "Hybrid-Ready",
    description: "Play online, offline, or both",
  },
  {
    gifUrl:
      "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExOWI2bG9lYTRsa2I1bjFiY3RyNndiamVvY2xpZGZ5NWdnNzZmd2J4bSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/MXjYDfYqA8ry25lUtJ/giphy.gif",
    title: "Scales Easily",
    description: "10 or 1,000 players? Works just the same!",
  },
];

export default function WhyBingoComponent() {
  const [visibleCards, setVisibleCards] = useState([]);
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            features.forEach((_, index) => {
              setTimeout(() => {
                setVisibleCards((prev) => [...prev, index]);
              }, index * 200);
            });
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -20px 0px",
      }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [hasAnimated]);

  return (
    <Box
      ref={sectionRef}
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        py: { xs: 4, md: 8 },
        px: { xs: 1, sm: 2 },
        overflow: "hidden",
        position: "relative",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "10%",
          left: "5%",
          width: { xs: 48, md: 96 },
          height: { xs: 48, md: 96 },
          borderRadius: "50%",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          animation: "float 4s ease-in-out infinite",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "15%",
          right: "8%",
          width: { xs: 64, md: 128 },
          height: { xs: 64, md: 128 },
          borderRadius: "50%",
          backgroundColor: "rgba(255, 255, 255, 0.05)",
          animation: "float 4s ease-in-out infinite",
        }}
      />

      <Container maxWidth="xl">
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 8 } }}>
          <Typography
            variant="h5"
            sx={{
              color: "white",
              fontWeight: 900,
              lineHeight: 1.2,
              mb: 1,
              fontSize: { xs: "2rem", lg: "3rem" },
            }}
          >
            Why Bingo Social
          </Typography>
          <Typography
            variant="h5"
            sx={{ color: "rgba(255,255,255,0.9)", fontWeight: 300 }}
          >
            A Game Everyone Gets - And Loves to Play
          </Typography>
        </Box>

        <Grid container spacing={{ xs: 2, md: 4 }} sx={{ justifyContent: "center" }}>
          {features.map((feature, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={2.4}
              xl={2.4}
              key={index}
              sx={{
                display: "flex",
                justifyContent: "center",
                transform: visibleCards.includes(index)
                  ? "translateY(0) scale(1)"
                  : "translateY(50px) scale(0.95)",
                opacity: visibleCards.includes(index) ? 1 : 0,
                transition: "all 0.8s ease-out",
              }}
            >
              <Card
                sx={{
                  width: "100%",
                  // maxWidth: { xs: 280, sm: 300, md: 280, lg: 450, xl: 450 },
                  height: { xs: 380, sm: 400, md: 420, lg: 4500, xl: 450 },
                  borderRadius: 4,
                  backgroundColor: "rgba(255,255,255,0.95)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255,255,255,0.2)",
                  boxShadow: "0px 20px 40px -10px rgba(0,0,0,0.3)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                  p: { xs: 1.5, sm: 2, lg: 2 },
                  cursor: "pointer",
                  textAlign: "center",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-8px) scale(1.02)",
                    backgroundColor: "white",
                    boxShadow: "0px 25px 50px -5px rgba(0,0,0,0.4)",
                  },
                }}
              >
                <Box sx={{ mb: 1, position: "relative", flex: 1 }}>
                  <Box
                    sx={{
                      width: { xs: 180, sm: 200, md: 180, lg: 250, xl: 250 },
                      height: { xs: 240, sm: 260, md: 240, lg: 350, xl: 350 },
                      borderRadius: 3,
                      overflow: "hidden",
                      transition: "transform 0.3s",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={feature.gifUrl}
                      alt={feature.title}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        filter: "brightness(1.1) contrast(1.1)",
                      }}
                    />
                  </Box>
                </Box>
                <CardContent sx={{ py: 1, px: 0 }}>
                  <Typography
                    variant="h6"
                    sx={{ 
                      fontWeight: "bold", 
                      mb: 0.5, 
                      color: "#1f2937",
                      fontSize: { xs: "1rem", sm: "1.1rem", lg: "0.95rem", xl: "1rem" }
                    }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: "#4b5563",
                      fontSize: { xs: "0.8rem", sm: "0.85rem", lg: "0.75rem", xl: "0.8rem" },
                      lineHeight: 1.3
                    }}
                  >
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
        `}
      </style>
    </Box>
  );
}